import React from "react";
import { STATUS_CONFIG } from "./mockProjectData";

const ResourceCard = ({ resource }) => {
  const statusCfg = STATUS_CONFIG[resource.status] || STATUS_CONFIG["Available"];

  return (
    <div
      style={{
        borderLeft: `4px solid ${resource.color.border}`,
        background: resource.color.bg,
        borderRadius: 8,
        padding: "10px 12px",
        height: "100%",
        minHeight: 100,
        boxSizing: "border-box",
        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
        transition: "box-shadow 0.15s",
        cursor: "default",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.13)")}
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.07)")}
    >
      {/* Name + status badge */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 8,
          marginBottom: 3,
        }}
      >
        <span
          style={{
            fontSize: 13,
            fontWeight: 700,
            color: resource.color.nameColor,
            lineHeight: 1.3,
          }}
        >
          {resource.name}
        </span>
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: statusCfg.textColor,
            background: statusCfg.bg,
            padding: "2px 8px",
            borderRadius: 12,
            whiteSpace: "nowrap",
            flexShrink: 0,
            letterSpacing: "0.04em",
          }}
        >
          {statusCfg.label}
        </span>
      </div>

      {/* Role */}
      <div style={{ fontSize: 11, color: "#64748b", marginBottom: 2 }}>
        {resource.role}
      </div>

      {/* Department */}
      <div style={{ fontSize: 11, fontWeight: 600, color: "#475569", marginBottom: 5 }}>
        {resource.department} Team
      </div>

      {/* Task description (2-line clamp) */}
      <div
        title={resource.task}
        style={{
          fontSize: 11,
          color: "#64748b",
          lineHeight: 1.45,
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {resource.task}
      </div>
    </div>
  );
};

export default ResourceCard;